import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cipo-outline-field',
  imports: [NgClass, TranslateModule],
  templateUrl: './cipo-outline-field.component.html',
})
export class CipoOutlineFieldComponent {
  readonly defaultBgColorClass = 'cipo-bg--black-50';

  label = input<string>('');
  compactMode = input(false);
  markChanged = input(false);
  error = input(false);
  required = input(false);

  /** Background color class */
  bgColorClass = input<string>(this.defaultBgColorClass);
}
